import { THANK_YOU_SUB_TITLE_SET } from './types';

export const setThankYouSubTitle = subTitle => {
    return {
        type: THANK_YOU_SUB_TITLE_SET,
        payload: subTitle
    };
};
